@if (sortedItems && columns) {
  <div class="cl">
    @if (!hideHeader) {
      <div class="cl-header">
        <div class="cl-columns">
          @for (column of columns; track trackByFunction(i, column); let i = $index) {
            @if (column.visible) {
              <div class="cl-column" [class.can-sort]="isSortable"
                (click)="toggleColumn(column)"
                [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                @if (column.icon) {
                  <span [innerHtml]="column.icon" [matTooltip]='column.name | translate'></span>
                } @else {
                  <span>{{ column.name | translate}}</span>
                }
                @if (isSortable) {
                  <span class="sort-icon">
                    @if (column.sort) {
                      @if (column.sort === 'asc') {
                        <i class="fas fa-long-arrow-alt-down"></i>
                      } @else {
                        <i class="fas fa-long-arrow-alt-up"></i>
                      }
                    }
                  </span>
                }
              </div>
            }
          }
        </div>
        @if (canToggleColumns) {
          <div class="cl-menu" [matMenuTriggerFor]="menu">
            <i class="fas fa-ellipsis-v"></i>
          </div>
        }
        <mat-menu #menu="matMenu">
          @for (column of columns; track trackByFunction($index, column)) {
            <button mat-menu-item>
              <mat-checkbox class="column-checkbox" [checked]="column.visible"
                (change)="changeColumnVisibility(column, $event)" (click)="$event.stopPropagation();">
                {{column.name | translate}}
              </mat-checkbox>
            </button>
          }
        </mat-menu>
      </div>
    }
    <div class="cl-items" [ngClass]="{ dynamicHeight: getDynamicHeight() != undefined}" [style.height]="getDynamicHeight()">
      <!-- virtual scroller for performance: https://material.angular.io/cdk/scrolling/overview -->
      <cdk-virtual-scroll-viewport #viewPort itemSize="35" class="virtual-scroll-container">
        <div *cdkVirtualFor="let item of sortedItems; trackBy: trackByFunction"
          class="cl-item"
                    [ngClass]="{
                        selected: item.selected, 
                        highlighted: item.highlighted,
                        semihighlighted: item.semiHighlighted,
                        criticalhighlighted: item.criticalHighlighted,
                        muted: item.muted
                    }"
          (mousedown)="itemClicked(item)">
          @if (item.highlighted || item.semiHighlighted) {
            <div class="highligted-marker"></div>
          }
          @for (column of columns; track trackByFunction($index, column)) {
            @if (column.visible) {
              @switch (column?.template) {
                @case ('tags') {
                  <div class="cl-column tags"
                    [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    @if (item.properties[column.key]) {
                      <div class="cl-content tag-base cl-tag"
                        [style.background-color]="item.properties[column.tagColorKey]">
                        {{item.properties[column.key]}}
                      </div>
                    }
                  </div>
                }
                @case ('dots') {
                  <div class="cl-column"
                    [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    <app-speed-dots [speed]="item.properties[column.key]"></app-speed-dots>
                  </div>
                }
                @case ('bearing') {
                  <div class="cl-column"
                    [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px', 'color': item.properties['color']}">
                    <!-- Magic number 41 is to rotate font-awesome icon to 0 degrees (north) -->
                    <span class="cl-bearing"
                      [ngStyle]="{'transform': 'rotate(' + (item.properties[column.key] - 41) % 360 + 'deg)'}">
                      <i class="fas fa-location-arrow fa-rotate-by"></i>
                    </span>
                  </div>
                }
                @case ('color') {
                  <div class="cl-column cl-color color">
                    <div class="color-dot" [ngStyle]="{'background-color': column.color}"></div>
                  </div>
                }
                @case ('vehicleList') {
                  <div class="cl-column" [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    <div class="cl-vehicle-list vehicle-list">
                      @if (item) {
                        @for (vehicle of item.properties[column.key]; track trackByFunction($index, vehicle)) {
                          @if (vehicle?.departureDeviation?.color ?? vehicle?.arrivalDeviation?.color) {
                            <div>
                              <div class="circle" [style.background]="vehicle?.departureDeviation?.color ?? vehicle?.arrivalDeviation?.color">
                              </div>
                            </div>
                          }
                        }
                      }
                    </div>
                  </div>
                }
                @case ('warningIcon') {
                  <div class="cl-column cl-warning-icon" [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    <div class="cl-warning-icon">
                      <app-warning-icon messageType={{item.properties[column.key]}}></app-warning-icon>
                    </div>
                  </div>
                }
                @case ('warningList') {
                  <div class="cl-column" [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    <div class="cl-warning-icon">
                      @if (item) {
                        @for (warningType of item.properties[column.key]; track trackByFunction($index, warningType)) {
                          <app-warning-icon [messageType]="warningType"></app-warning-icon>
                        }
                      }
                    </div>
                  </div>
                }
                @case ('customColumnTemplate') {
                  <div class="cl-column" [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    @for (customColumn of customColumnList; track customColumn) {
                      @if (customColumn.columnName === column.key) {
                        <ng-container
                          [ngTemplateOutlet]="customColumn.template"
                          [ngTemplateOutletContext]="{$implicit:item,onCustomColumnButtonClick:customColumnButtonClick}">
                        </ng-container>
                      }
                    }
                  </div>
                }
                @default {
                  <div class="cl-column"
                    [ngStyle]="{'flex-basis': calculatedColumnWidth[column.key] + 'px'}">
                    <div
                      class="cl-content"
                      [matTooltip]="item.properties[column.key]"
                      matTooltipPosition="right">
                      {{item.properties[column.key]}}
                    </div>
                  </div>
                }
              }
            }
          }
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
}